import { HttpResponse, HttpResponseResolver } from 'msw';

import { CollectionStatus, LoginMethod } from '@main/types';

import { mockDb } from '../../mockDb';

export const getResumableCollectionsHandler: HttpResponseResolver = ({ params }) => {
  const code = params.code as string;

  let collections = [
    mockDb.collection.create({
      insuranceCompany: 'se-demo',
      status: CollectionStatus.COMPLETED,
    }),
  ];

  // get two collections back if code starts with a 2
  if (code[0] === '2') {
    collections = [
      ...collections,
      mockDb.collection.create({
        insuranceCompany: 'se-swedbank',
        status: CollectionStatus.COMPLETED,
      }),
    ];
  }

  const resumableCollections = collections.map((c) => ({
    company: c.insuranceCompany,
    loginMethod: LoginMethod.SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION,
    // get started collections back if last character is a 2
    collectionId: code[code.length - 1] === '2' ? c.id : undefined,
  }));

  return HttpResponse.json(
    {
      customerId: CUSTOMER_ID,
      configName: CONFIG_NAME,
      resumableCollections,
      attributes: {
        returnUrl: window.location.href,
      },
    },
    { status: 200 },
  );
};
